export enum SocketEvents {
  CONNECT = "connection",
  DISCONNECT = "disconnect",
  NOTIFY = "notify",
  NOTIFY_RESP = "notifyResponse",
  SETUP = "setup",
}
